export enum AppNavigationOptionsEnum {
    MY_ORDERS_GENOTYPING_ORDERS = 'my-orders-genotypingOrders',
    MY_ORDERS_GENETIC_MONITORING = 'my-orders-geneticMonitoringOrders',
    MY_ORDERS_MICROBIOME_ORDERS = 'my-orders-microbiomeOrders',
    MY_ORDERS_START_NEW_ORDER = 'my-orders-startNewOrder',
    MY_ORDERS_CHECKMATE = 'my-orders-checkmate',
    MY_ORDERS_RESULTS_AVAILABILITY_SCHEDULE = 'my-orders-resultsAvailabilitySchedule',
    MY_ORDERS_WELLPLATE_STORAGE = 'my-orders-wellplateStorage',
    MY_ORDERS_FAQ = 'my-orders-orderFAQ',

    MY_SUPPLIES_OVERVIEW = 'my-supplies-overview',
    MY_SUPPLIES_REQUEST_SUPPLIES = 'my-supplies-requestSupplies',
    MY_SUPPLIES_FAQ = 'my-supplies-supplyFAQ',

    MY_STRAINS_LISTING = 'my-strains-myStrains',
    MY_STRAINS_CREATE_NEW_STRAIN = 'my-strains-createNewStrain',
    MY_STRAINS_STRAIN_SHARING = 'my-strains-strainSharing',
    MY_STRAINS_SEQUENCING_REQUESTS = 'my-strains-sequencingRequests',
    MY_STRAINS_MY_PROBES = 'my-strains-myProbes',
    MY_STRAINS_FAQ = 'my-strains-strainsFAQ',
}
